!(function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e.STROPHY_GT = {}));
})(this, function (e) {
    "use strict";
    var t = 32,
        n = function () {
            console.warn("[DEPRECATE] waitForInit() is deprecated and will be removed soon."),
                setTimeout(function () {
                    STROPHY.texturesReady ? STROPHY.initAssets() : n();
                }, 1e3);
        },
        a = function (e, t, n, a, i, f) {
            return new Promise(function (r, l) {
                imageLoaded(e).then(function (c) {
                    !0 === c
                        ? o(t, e, n, a, i, f).then(function (e) {
                              r(e);
                          })
                        : (window.setTimeout(function () {
                              STROPHY._updateTextures(f);
                          }, 100),
                          l("Not loaded"));
                });
            });
        },
        i = function (e, n, a, i, o) {
            var f = o.length,
                r = 16,
                l = t;
            switch (((e.fillStyle = "rgba(0,0,0,1)"),(e.globalAlpha=1), (e.textAlign = "center"), (e.lineWidth = l), i)) {
                case "body":
                    for (var c = 0; c < f; c++) {
                        switch (c) {
                            case 0:
                                (r = 24), (l = 32);
                                break;
                            default:
                                (r = 16), (l = t);
                        }
                        (e.font =  r + 'px "Academy Engraved"'), e.fillText(o[c].text, n, a + l * c);
                    }
                    break;
                case "plate":
                    for (c = 0; c < f; c++) {
                        switch (c) {
                            case 0:
                                (r = 113), (l = 118);
                                break;
                            default:
                                (r = 64), (l = 118);
                        }
                        (e.font = r + 'px "Academy Engraved"'), e.fillText(o[c].text, n, a + l * c);
                    }
                    break;
                    case "medal-lv":
                        for (var c = 0; c < f; c++) {
                            switch (c) {
                                case 0:
                                    (r = 72), (l = 90);
                                break;
                                default:
                                     (r = 72), (l = 90);
                                }
                                (e.font =  r + 'px "Academy Engraved"'), e.fillText(o[c].text, n, (a +l*c)/1.05);
                        }
                        break;
                        case "medal-p":
                            for (var c = 0; c < f; c++) {
                                switch (c) {
                                    case 0:
                                        (r = 64), (l = 90);
                                break;
                                default:
                                    (r = 64), (l = 90);
                                }
                                (e.font =  r + 'px "Academy Engraved"'), e.fillText(o[c].text, n, (a +l*c)/1.05);
                            }
                            break;
                default:
                    console.error("Invalid texture target: " + i);
            }
            return e;
        },
        o = function (e, t, n, a, i, o) {
            return new Promise(function (i, o) {
                (e.fillStyle = "#ffffff"), e.fillRect(0, 0, n / 2, a / 2), e.drawImage(t, 0, 0, t.width, t.height, n / 2 - t.width / 2, a / 2 - t.height / 2, t.width, t.height), i(e);
            });
        };
    function f(e, t, n, a, o) {
        return new Promise(function (a, o) {
            var f = document.createElement("canvas");
            (f.width = e / 2), (f.height = t / 2);
            var r = e / 4,
                l = t / 4,
                c = f.getContext("2d");
            (c.fillStyle = "#fff"), 
            (c.globalAlpha = 1),
            c.fillRect(0, 0, e / 2, t / 2), (c = i(c, r, l, n.target, n.datas)), a(f);
        });
    }
    (e.Text = f),
    (e.PlateText = function (e, t, n, a) {
        return console.warn("[DEPRECATE] STROPHY_GT.PlateText() is deprecated, use STROPHY_GT.Text() instead."), f(e, t, { target: "plate", datas: [{ text: n }, { text: a }] });
    }),
    (e.Image = function (e, t, n, i, o) {
        return new Promise(function (i, f) {
            var r = document.createElement("canvas");
            (r.width = e), (r.height = t);
            var l = r.getContext("2d"),
                c = c || !1;
                (l.fillStyle = "#ffffff"), l.fillRect(0, 0, e, t);
                (r.style.backgroundColor = 'rgba(0, 0, 0, 0.3)');
            var d = new Image();
                (d.src = n),
                a(d, l, e, t, c, o)
                    .then(function (e) {
                        (l = e), i(r);
                    })
                    .catch(function (e) {
                        i(r);
                    });
        });
    }),
    (e.WallImage = function (e, t, a, i) {
        var o = document.createElement("canvas");
            (o.width = e), (o.height = t);
            var f = 0,
                r = o.getContext("2d");
            if (((r.fillStyle = "#ffffff"), r.fillRect(0, 0, e, t), void 0 !== a[0])) {
                for (var l = 0; f < 12; l++) a[l] ? (STROPHY.imageLoaders.push(STROPHY.loadSprite(r, a[l], f)), f++) : (l = -1);
                $.when.apply(null, STROPHY.imageLoaders).done(function () {
                    (STROPHY.texturesReady = !0),
                        STROPHY.texturesReady
                            ? setTimeout(function () {
                                  STROPHY.initAssets();
                              }, 0)
                            : n();
                });
            } else
                setTimeout(function () {
                    STROPHY.initAssets();
                }, 100);
            return o;
        }),
        (e.CertImage = function (e, n, a, i, o, f, r, l) { //e -src n, a - h/w, i, o,f,r,l -txtDisplayName, txtDisplayEvtName, txtDisplayPlatz, txtDisplayDatum
            return new Promise(function (e, c) {
                var d = document.createElement("canvas");
                (d.width = n), (d.height = a);
                var s = n / 2,
                    u = a / 2,
                    g = document.querySelector(".certBg"),
                    x = document.querySelector(".spooortsLogo"),
                    m = d.getContext("2d");
                m.clearRect(0, 0, d.width, d.height),
                    (m.fillStyle = "#ffffff"),
                    m.fillRect(0, 0, n, a),
                    m.drawImage(g, 0, 0, n, a),
                    m.save(),
                    document.fonts
                        ? document.fonts.load('32px "Academy Engraved"').then(function () {
                              (m.fillStyle = "rgba(0,0,0,1)"),
                                  (m.textAlign = "center"),
                                  (m.lineWidth = t),
                                  i && ((m.font = '64px "Academy Engraved"'), m.fillText(i, s, u)),
                                  o && ((m.font = '32px "Academy Engraved"'), m.fillText(o, s, u + t)),
                                  f && ((m.font = '32px "Academy Engraved"'), m.fillText(f, s, u + 2 * t)),
                                  r && ((m.font = '47px "Academy Engraved"'), m.fillText(r, s, u + 4 * t)),
                                  l && ((m.font = '32px "Academy Engraved"'), m.fillText(l, s, u + 5 * t)),
                                  m.save(),
                                  m.drawImage(x, s - x.width / 2, u / 1.7 - x.height / 2),
                                  e(d);
                          })
                        : ((m.fillStyle = "rgba(0,0,0,1)"),
                          (m.strokeStyle = "rgba(0,0,0,0)"),
                          (m.textAlign = "center"),
                          i && (m.strokeText(i, s, u), m.fillText(i, s, u)),
                          o && ((m.font = '32px "Academy Engraved"'), m.fillText(o, s, u + t)),
                          f && ((m.font = '32px "Academy Engraved"'), m.fillText(f, s, u + 2 * t)),
                          r && ((m.font = '47px "Academy Engraved"'), m.fillText(r, s, u + 4 * t)),
                          l && ((m.font = '32px "Academy Engraved"'), m.fillText(l, s, u + 5 * t)),
                          m.save(),
                          m.drawImage(x, s - x.width / 2, u / 1.7 - x.height / 2),
                          console.log("%cFontFaceSet not supported. Fallback texture has been applied.", "color: #2196f3"),
                          e(d));
            });
        })
});
